"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    attributeVariants: ()=>attributeVariants
});
const tv_cjs_namespaceObject = require("../../variants/tv.cjs");
const attributeVariants = (0, tv_cjs_namespaceObject.tv)({
    slots: {
        root: 'flex flex-row items-center gap-1',
        iconSlot: '',
        imageIconWrapperSlot: 'relative flex flex-col items-center justify-center',
        imageSlot: '',
        textSlot: 'text-center'
    },
    variants: {
        hasIcon: {
            true: {}
        },
        isActionable: {
            true: {
                root: 'group/attribute group hover:cursor-pointer',
                textSlot: 'group-hover/attribute:underline'
            }
        },
        isVertical: {
            true: {
                root: 'flex-col'
            },
            false: {
                root: 'flex-row'
            }
        },
        showImage: {
            true: {
                iconSlot: 'text-neutral-1 absolute block w-full text-center'
            }
        },
        size: {
            sm: {},
            md: {}
        }
    },
    compoundVariants: [
        {
            isVertical: true,
            size: 'sm',
            class: {
                imageIconWrapperSlot: 'h-8 w-8'
            }
        },
        {
            isVertical: true,
            size: 'md',
            class: {
                imageIconWrapperSlot: 'h-10 w-10'
            }
        },
        {
            isVertical: true,
            showImage: true,
            class: {
                imageIconWrapperSlot: 'w-10'
            }
        },
        {
            hasIcon: true,
            isVertical: true,
            class: {
                imageSlot: 'brightness-[70%]'
            }
        }
    ],
    defaultVariants: {
        hasIcon: false,
        isVertical: false,
        showImage: false,
        size: 'md'
    }
});
exports.attributeVariants = __webpack_exports__.attributeVariants;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "attributeVariants"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
